<template>
    <el-radio-group v-model="newValue" name="radioGroup" @change="handleChange">
        <el-radio v-if="showAllRadio" :value="undefined">
            <gljy-span>全部</gljy-span>
        </el-radio>
        <el-radio v-for="item in options" :key="item[fieldNames.value]" :label="item[fieldNames.value]"
            :value="item[fieldNames.value]" :disabled="isDisabledValue(item)">{{ i18nConfig(item[fieldNames.label])
            }}</el-radio>
    </el-radio-group>
</template>

<script>
import { i18nConfig } from '@/utils/ruoyi'
import useDictStore from '@/store/modules/dict';
import { getDicts } from '@/api/system/dict/data';
import { ref, reactive, toRefs, watch, onMounted } from "vue";
export default {
    name: "gljy-radio",
    emits: ["update:value", "update:label", "change", "resultQueryData"],
    props: {
        // dict; 数据字典   queryFunction;查询函数  queryUrl;查询url地址
        type: {
            type: String,
            default: "queryFunction"
        },
        value: {
            type: [String, Number, Array]
        },
        label: {
            type: [String, Number, Array]
        },
        // 查询函数--type-queryFunction时,此函数必须配置
        queryFunction: {
            type: [Function, Promise],
            default: () => {
                return () => { };
            }
        },
        // 查询条件--跟queryFunction配套使用
        extendQueryWhere: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 是否自动触发 查询
        isAutoInit: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        // 是否缓存
        isCache: {
            type: Boolean,
            default: () => {
                return true;
            }
        },
        // 显示全部按钮
        showAllRadio: Boolean,
        dataSource: {
            type: Array,
        },
        fieldNames: {
            type: Object,
            default: () => {
                return {
                    value: "dictValue",
                    label: "dictLabel",
                }
            }
        },
        // 禁用选择字段
        disabledValues: {
            type: [Array, String],
            default: () => {
                return []
            }
        },
    },
    setup(props, context) {
        const dicts = useDictStore();
        const datas = reactive({
            newValue: undefined,
            options: [],
            i18nConfig: i18nConfig
        })


        const methods = {
            // 初始化
            async init(params) {
                // console.log("fieldNames-----", props.fieldNames)
                if (props.type == null || props.type == "") return;
                const dict = dicts.dict;
                if (props.type == "queryFunction" || props.type == "queryUrl") {
                    let data = {};
                    if (props.extendQueryWhere) {
                        Object.keys(props.extendQueryWhere).forEach(key => {
                            data[key] = props.extendQueryWhere[key]
                        })
                    }
                    if (params) {
                        Object.keys(params).forEach(key => {
                            data[key] = params[key]
                        })
                    }
                    let funName = methods.getFunctionName(props.queryFunction);
                    if (props.type == "queryUrl") {
                        funName = props.url;
                    }
                    let keyStr = `${funName}-${JSON.stringify(props.extendQueryWhere)}-${JSON.stringify(params)}`;
                    if (dict && dict[keyStr] && props.isCache && dict[keyStr] != "notCache") {
                        datas.options = dict[keyStr];
                        methods.setCustomField(datas.options);
                        methods.setValueDisabled();
                        return;
                    } else if (dict[keyStr] != null && dict[keyStr] == "notCache" && props.isCache) {
                        setTimeout(() => {
                            methods.init(params);
                        }, 1000);
                    } else {
                        dicts.setDict(keyStr, "notCache");
                        let res = null;
                        if (props.type == "queryUrl") {
                            res = await system.hsSelectQueryFunction(props.url, data);
                        } else {
                            if ((typeof props.queryFunction) == "object") {
                                const functionAwait = await props.queryFunction;
                                res = await functionAwait(data);
                            } else {
                                res = await props.queryFunction(data);
                            }
                        }
                        context.emit("resultQueryData", res);
                        if (res.code == 200) {
                            datas.options = res.data;
                            methods.setCustomField(datas.options);
                            if (props.isCache) {
                                dicts.setDict(keyStr, res.data);
                            }
                        } else {
                            datas.options = [];
                            if (props.isCache) dicts.setDict(keyStr, []);
                        }
                    }

                } else if (props.type == "dataSource") {
                    datas.options = props.dataSource;
                } else {
                    if (dict && dict[props.type] && props.isCache && dict[props.type] != "notCache") {
                        datas.options = dict[props.type];
                        methods.setCustomField(datas.options);
                        methods.setValueDisabled();
                        return;
                    } else if (dict[props.type] != null && dict[props.type] == "notCache" && props.isCache) {
                        setTimeout(() => {
                            methods.init(params);
                        }, 1000);
                    } else {
                        dicts.setDict(props.type, "notCache");
                        const res = await getDicts(props.type);
                        context.emit("resultQueryData", res);
                        if (res.code == 200) {
                            datas.options = res.rows;
                            methods.setCustomField(datas.options);
                            if (props.isCache) dicts.setDict(props.type, res.rows);
                        }
                    }
                }
                methods.setValueDisabled();
            },
            // 设置禁用字段
            setValueDisabled() {
                const disabledValues = props.disabledValues;
                if (disabledValues != null && disabledValues.length > 0) {
                    disabledValues.forEach(value => {
                        const find = datas.options.find(f => f[props.fieldNames.value] == value);
                        if (find) {
                            find.disabled = true;
                        }
                    })
                }
            },
            // 设置自定义label值
            setCustomField(rows) {
                if (props.fieldNames.customField != null && typeof props.fieldNames.customField == "function") {
                    rows.forEach(item => {
                        props.fieldNames.customField(item);
                    })
                }
            },
            handleChange(value) {
                if (value == null || value == "null" || value === undefined || value == "undefined") {
                    datas.newValue = null;
                    context.emit("update:value", undefined);
                    context.emit("update:label", undefined);
                    return;
                }
                const find = datas.options.find(item => item[props.fieldNames.value] == value);
                // console.log("find", find, find[props.fieldNames.value], find[props.fieldNames.label])
                context.emit("update:value", find[props.fieldNames.value]);
                context.emit("update:label", find[props.fieldNames.label]);
                context.emit("change", value, { find, options: datas.options });
            },
            // 设置禁用项
            isDisabledValue(item) {
                if (!props.disabledValues) return false;
                const disabledValues = props.disabledValues.toString();
                if (disabledValues.indexOf(item[props.fieldNames.value]) >= 0) {
                    return true;
                }
                return false;
            }
        }

        watch(() => props.dataSource, () => {
            if (props.type == "dataSource") {
                datas.options = props.dataSource;
            }
        }, { immediate: true })

        watch(() => props.value, () => {
            if (props.type != 'queryFunction' && props.type != 'dataSource') {
                datas.newValue = props.value + '';
            } else {
                datas.newValue = props.value;
            }
            if (props.value == null || props.value == "null" || props.value === undefined || props.value == "undefined") {
                if (props.mode == "multiple") {
                    datas.newValue = [];
                } else {
                    datas.newValue = undefined;
                }
            }
        }, { immediate: true })

        onMounted(() => {
            // 自动触发查询
            if (props.isAutoInit) {
                methods.init();
            }
        })

        return {
            ...toRefs(datas),
            ...methods
        }
    }
}
</script>

<style></style>